export const tradeDataP = [
  {
    "terminal": "潍坊火烧",
    "name": "刘忠泽",
    "time": "2025-09-16 20:42:51",
    "amount": 5,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "金陵炸鸡腿",
    "name": "李寒阳",
    "time": "2025-09-16 20:28:22",
    "amount": 7.5,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "李书畅",
    "time": "2025-09-16 20:21:43",
    "amount": 5,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "金陵炸鸡腿",
    "name": "冯建廷",
    "time": "2025-09-16 20:18:25",
    "amount": 8,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "潍坊火烧",
    "name": "李书畅",
    "time": "2025-09-16 20:15:17",
    "amount": 6,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "李书畅",
    "time": "2025-09-16 20:12:53",
    "amount": 3.5,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "基本大伙23",
    "name": "张雨晴",
    "time": "2025-09-16 20:07:27",
    "amount": 1,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "肥饱饱",
    "name": "李甜",
    "time": "2025-09-16 20:02:32",
    "amount": 13.2,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "肥饱饱",
    "name": "仲丽雯",
    "time": "2025-09-16 20:02:26",
    "amount": 13.8,
    "meal": "宵夜",
    "type": "扫码"
  },
  {
    "terminal": "兰州拉面",
    "name": "臧一硕",
    "time": "2025-09-16 20:01:53",
    "amount": 8,
    "meal": "宵夜",
    "type": "账户消费"
  },
  {
    "terminal": "德客堡-中国汉堡",
    "name": "张天祥",
    "time": "2025-09-16 19:55:49",
    "amount": 12.9,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "潍坊火烧",
    "name": "张其光",
    "time": "2025-09-16 19:49:29",
    "amount": 6,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "新疆炒米粉-炒面",
    "name": "刘海瑞",
    "time": "2025-09-16 19:33:29",
    "amount": 10,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "金陵炸鸡腿",
    "name": "王鸿森",
    "time": "2025-09-16 19:33:20",
    "amount": 6.9,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "金陵炸鸡腿",
    "name": "王一诺",
    "time": "2025-09-16 19:28:07",
    "amount": 6.5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "炫饱饱小锅焖面",
    "name": "苗艺轩",
    "time": "2025-09-16 19:20:17",
    "amount": 12.9,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "炫饱饱小锅焖面",
    "name": "张馨月",
    "time": "2025-09-16 19:19:54",
    "amount": 10.9,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "慢茶",
    "name": "魏钰函",
    "time": "2025-09-16 19:19:30",
    "amount": 4,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "颜廷磊",
    "time": "2025-09-16 19:15:32",
    "amount": 8.5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "石长屹",
    "time": "2025-09-16 19:09:20",
    "amount": 5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "石长屹",
    "time": "2025-09-16 19:08:59",
    "amount": 9.5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "金陵炸鸡腿",
    "name": "王美涵",
    "time": "2025-09-16 19:08:36",
    "amount": 6,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "兰州拉面",
    "name": "刘丰硕",
    "time": "2025-09-16 18:50:24",
    "amount": 4,
    "meal": "晚餐",
    "type": "账户消费"
  },
  {
    "terminal": "炫饱饱小锅焖面",
    "name": "刘丰硕",
    "time": "2025-09-16 18:47:53",
    "amount": 10.9,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "谭小青麻辣烫-麻辣拌",
    "name": "王鑫雨",
    "time": "2025-09-16 18:46:37",
    "amount": 12.8,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "滑蛋饭-鸭腿饭",
    "name": "周道龙",
    "time": "2025-09-16 18:46:17",
    "amount": 12,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "基本大伙23",
    "name": "吴梦瑶",
    "time": "2025-09-16 18:44:25",
    "amount": 7.5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "茶香鸡",
    "name": "马鑫",
    "time": "2025-09-16 18:44:15",
    "amount": 12,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "新疆炒米粉-炒面",
    "name": "胡明嘉",
    "time": "2025-09-16 18:44:13",
    "amount": 7,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "德客堡-中国汉堡",
    "name": "牛镇远",
    "time": "2025-09-16 18:38:36",
    "amount": 19,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "史娅楠",
    "time": "2025-09-16 18:33:16",
    "amount": 5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "王瑞祥",
    "time": "2025-09-16 18:33:15",
    "amount": 5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "王志诚",
    "time": "2025-09-16 18:31:49",
    "amount": 9,
    "meal": "晚餐",
    "type": "聚合支付扫码"
  },
  {
    "terminal": "慢茶",
    "name": "荆妍雅",
    "time": "2025-09-16 18:24:19",
    "amount": 7,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "慢茶",
    "name": "韩正一",
    "time": "2025-09-16 18:22:54",
    "amount": 2,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "炫饱饱小锅焖面",
    "name": "徐浩",
    "time": "2025-09-16 18:22:50",
    "amount": 11.9,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "基本大伙23",
    "name": "闫纪晨",
    "time": "2025-09-16 18:22:42",
    "amount": 10,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "基本大伙23",
    "name": "李文祺",
    "time": "2025-09-16 18:21:20",
    "amount": 10,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "烘焙水果捞",
    "name": "雷雨霏",
    "time": "2025-09-16 18:18:23",
    "amount": 12.7,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "炫饱饱小锅焖面",
    "name": "贾子璇",
    "time": "2025-09-16 18:17:34",
    "amount": 10.9,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "兰州拉面",
    "name": "张铭松",
    "time": "2025-09-16 18:16:44",
    "amount": 8,
    "meal": "晚餐",
    "type": "账户消费"
  },
  {
    "terminal": "德客堡-中国汉堡",
    "name": "殷凡",
    "time": "2025-09-16 18:16:04",
    "amount": 16,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "新疆炒米粉-炒面",
    "name": "马烁然",
    "time": "2025-09-16 18:13:23",
    "amount": 7,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "苏国凡",
    "time": "2025-09-16 18:12:49",
    "amount": 5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "基本大伙22",
    "name": "刘名哲",
    "time": "2025-09-16 18:12:01",
    "amount": 12,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "潍坊火烧",
    "name": "闫娜",
    "time": "2025-09-16 18:10:36",
    "amount": 3,
    "meal": "晚餐",
    "type": "聚合支付扫码"
  },
  {
    "terminal": "潍坊火烧",
    "name": "李佳睿",
    "time": "2025-09-16 18:10:28",
    "amount": 3,
    "meal": "晚餐",
    "type": "聚合支付扫码"
  },
  {
    "terminal": "基本大伙22",
    "name": "唐宇翔",
    "time": "2025-09-16 18:07:54",
    "amount": 13,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "鸡汤油饼",
    "name": "刘自豪",
    "time": "2025-09-16 18:07:14",
    "amount": 7.5,
    "meal": "晚餐",
    "type": "扫码"
  },
  {
    "terminal": "肥饱饱",
    "name": "赵丽燕",
    "time": "2025-09-16 18:04:15",
    "amount": 13.2,
    "meal": "晚餐",
    "type": "扫码"
  }
]